var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssessment = function SvgAssessment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 326,
    height: 419,
    fill: "none",
    viewBox: "0 0 326 419"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 315.357,
    height: 372.5,
    x: 65.179,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__c)",
    d: "M125.714 118.545c0-25.603 0-38.404 4.983-48.183a45.7 45.7 0 0 1 19.978-19.978c9.779-4.982 22.58-4.982 48.182-4.982h48c25.603 0 38.404 0 48.183 4.982a45.72 45.72 0 0 1 19.978 19.978C320 80.142 320 92.942 320 118.545v105.143c0 25.602 0 38.403-4.982 48.182a45.72 45.72 0 0 1-19.978 19.978c-9.779 4.982-22.58 4.982-48.183 4.982h-48c-25.602 0-38.403 0-48.182-4.982a45.7 45.7 0 0 1-19.978-19.978c-4.983-9.779-4.983-22.58-4.983-48.182z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 5.714,
    d: "M198.857 48.26h48c12.848 0 22.313.001 29.793.613 7.446.608 12.673 1.805 17.093 4.057a42.86 42.86 0 0 1 18.729 18.73c2.252 4.42 3.45 9.646 4.058 17.092.611 7.48.613 16.944.613 29.792v105.144c0 12.848-.002 22.312-.613 29.792-.608 7.446-1.806 12.673-4.058 17.093a42.86 42.86 0 0 1-18.729 18.729c-4.42 2.252-9.647 3.449-17.093 4.058-7.48.611-16.945.613-29.793.613h-48c-12.848 0-22.312-.002-29.792-.613-7.446-.609-12.673-1.806-17.093-4.058a42.86 42.86 0 0 1-18.729-18.729c-2.252-4.42-3.449-9.647-4.058-17.093-.611-7.48-.613-16.944-.613-29.792V118.544c0-12.848.002-22.312.613-29.792.609-7.446 1.806-12.673 4.058-17.092a42.86 42.86 0 0 1 18.729-18.73c4.42-2.252 9.647-3.45 17.093-4.057 7.48-.611 16.944-.614 29.792-.614Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 315.357,
    height: 372.5,
    x: 19.465,
    y: 45.714
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__e)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__f)",
    fillOpacity: 0.5,
    d: "M80 164.259c0-25.602 0-38.404 4.983-48.182a45.7 45.7 0 0 1 19.978-19.978c9.779-4.983 22.58-4.983 48.182-4.983h48c25.602 0 38.404 0 48.183 4.983a45.7 45.7 0 0 1 19.977 19.978c4.983 9.778 4.983 22.58 4.983 48.182v105.143c0 25.602 0 38.404-4.983 48.182a45.7 45.7 0 0 1-19.977 19.978c-9.779 4.983-22.58 4.983-48.183 4.983h-48c-25.602 0-38.403 0-48.182-4.983a45.7 45.7 0 0 1-19.978-19.978C80 307.806 80 295.004 80 269.402z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__g)",
    fillOpacity: 0.25,
    d: "M80 164.259c0-25.602 0-38.404 4.983-48.182a45.7 45.7 0 0 1 19.978-19.978c9.779-4.983 22.58-4.983 48.182-4.983h48c25.602 0 38.404 0 48.183 4.983a45.7 45.7 0 0 1 19.977 19.978c4.983 9.778 4.983 22.58 4.983 48.182v105.143c0 25.602 0 38.404-4.983 48.182a45.7 45.7 0 0 1-19.977 19.978c-9.779 4.983-22.58 4.983-48.183 4.983h-48c-25.602 0-38.403 0-48.182-4.983a45.7 45.7 0 0 1-19.978-19.978C80 307.806 80 295.004 80 269.402z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 5.714,
    d: "M153.143 93.974h48c12.848 0 22.313.002 29.793.613 7.446.608 12.673 1.806 17.093 4.057a42.86 42.86 0 0 1 18.729 18.73c2.252 4.419 3.449 9.647 4.058 17.093.611 7.479.613 16.944.613 29.792v105.143c0 12.848-.002 22.313-.613 29.792-.609 7.446-1.806 12.674-4.058 17.093a42.86 42.86 0 0 1-18.729 18.73c-4.42 2.251-9.647 3.449-17.093 4.057-7.48.611-16.945.614-29.793.614h-48c-12.848-.001-22.313-.003-29.792-.614-7.446-.608-12.673-1.806-17.093-4.057a42.86 42.86 0 0 1-18.73-18.73c-2.251-4.419-3.449-9.646-4.057-17.093-.611-7.479-.613-16.944-.613-29.792V164.259c0-12.848.002-22.313.613-29.792.608-7.446 1.806-12.674 4.058-17.093a42.86 42.86 0 0 1 18.729-18.73c4.42-2.251 9.647-3.449 17.093-4.057 7.479-.611 16.944-.613 29.792-.613Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 269.643,
    height: 143.928,
    x: 42.322,
    y: 91.428
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__i)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__j)",
    fillOpacity: 0.2,
    d: "M102.857 148.259c0-6.312 5.117-11.429 11.429-11.429H240c6.312 0 11.429 5.117 11.429 11.429 0 6.311-5.117 11.428-11.429 11.428H114.286c-6.312 0-11.429-5.117-11.429-11.428"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__k)",
    d: "M102.857 148.259c0-6.312 5.117-11.429 11.429-11.429H240c6.312 0 11.429 5.117 11.429 11.429 0 6.311-5.117 11.428-11.429 11.428H114.286c-6.312 0-11.429-5.117-11.429-11.428",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 5.714,
    d: "M114.286 139.688H240a8.57 8.57 0 0 1 8.571 8.571A8.57 8.57 0 0 1 240 156.83H114.286a8.57 8.57 0 0 1-8.571-8.571 8.57 8.57 0 0 1 8.571-8.571Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 246.786,
    height: 143.928,
    x: 42.322,
    y: 137.143
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__m)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__n)",
    fillOpacity: 0.2,
    d: "M102.857 193.973c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.429-11.428 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__o)",
    d: "M102.857 193.973c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.429-11.428 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 5.714,
    d: "M114.286 185.402h102.857a8.571 8.571 0 1 1 0 17.142H114.286a8.57 8.57 0 0 1-8.571-8.571 8.57 8.57 0 0 1 8.571-8.571Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 269.643,
    height: 143.928,
    x: 42.322,
    y: 182.857
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__p)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__q)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__r)",
    fillOpacity: 0.2,
    d: "M102.857 239.687c0-6.311 5.117-11.428 11.429-11.428H240c6.312 0 11.429 5.117 11.429 11.428s-5.117 11.429-11.429 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__s)",
    d: "M102.857 239.687c0-6.311 5.117-11.428 11.429-11.428H240c6.312 0 11.429 5.117 11.429 11.428s-5.117 11.429-11.429 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 5.714,
    d: "M114.286 231.116H240a8.57 8.57 0 0 1 8.571 8.572 8.57 8.57 0 0 1-8.571 8.571H114.286a8.57 8.57 0 0 1-8.571-8.571 8.57 8.57 0 0 1 8.571-8.572Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 246.786,
    height: 143.928,
    x: 42.322,
    y: 228.571
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.57px)",
      clipPath: "url(#assessment_svg__t)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.134,
    filter: "url(#assessment_svg__u)",
    shapeRendering: "crispEdges"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__v)",
    fillOpacity: 0.2,
    d: "M102.857 285.402c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.428-11.428 11.428H114.286c-6.312 0-11.429-5.116-11.429-11.428"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment_svg__w)",
    d: "M102.857 285.402c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.428-11.428 11.428H114.286c-6.312 0-11.429-5.116-11.429-11.428",
    style: {
      mixBlendMode: "screen"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 5.714,
    d: "M114.286 276.831h102.857a8.571 8.571 0 1 1 0 17.142H114.286a8.57 8.57 0 0 1-8.571-8.571 8.57 8.57 0 0 1 8.571-8.571Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.429,
    d: "m45.714 136.83-21.818 22.857-12.467-12.698",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.429,
    d: "m45.714 228.259-21.818 22.857-12.467-12.698",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.429,
    d: "m45.714 182.544-21.818 22.858-12.467-12.699",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.429,
    d: "M45.714 273.973 23.896 296.83 11.43 284.132",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__b",
    width: 315.357,
    height: 372.5,
    x: 65.179,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__e",
    width: 315.357,
    height: 372.5,
    x: 19.465,
    y: 45.714,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__i",
    width: 269.643,
    height: 143.928,
    x: 42.322,
    y: 91.428,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__m",
    width: 246.786,
    height: 143.928,
    x: 42.322,
    y: 137.143,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__q",
    width: 269.643,
    height: 143.928,
    x: 42.322,
    y: 182.857,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__u",
    width: 246.786,
    height: 143.928,
    x: 42.322,
    y: 228.571,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__x",
    width: 57.143,
    height: 45.714,
    x: 0,
    y: 131.116,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4361_3879",
    result: "effect2_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__y",
    width: 57.143,
    height: 45.714,
    x: 0,
    y: 222.544,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4361_3879",
    result: "effect2_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__z",
    width: 57.143,
    height: 45.714,
    x: 0,
    y: 176.83,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4361_3879",
    result: "effect2_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment_svg__A",
    width: 57.143,
    height: 45.714,
    x: 0,
    y: 268.259,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4361_3879",
    result: "effect2_dropShadow_4361_3879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4361_3879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__c",
    x1: 228.929,
    x2: 228.929,
    y1: 49.099,
    y2: 465.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__f",
    x1: 177.143,
    x2: 177.143,
    y1: 202.688,
    y2: 342.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__j",
    x1: 177.143,
    x2: 177.143,
    y1: 146.973,
    y2: 159.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__n",
    x1: 165.714,
    x2: 165.714,
    y1: 192.687,
    y2: 205.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__r",
    x1: 177.143,
    x2: 177.143,
    y1: 238.402,
    y2: 251.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment_svg__v",
    x1: 165.714,
    x2: 165.714,
    y1: 284.116,
    y2: 296.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__a",
    transform: "translate(-65.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.714 118.545c0-25.603 0-38.404 4.983-48.183a45.7 45.7 0 0 1 19.978-19.978c9.779-4.982 22.58-4.982 48.182-4.982h48c25.603 0 38.404 0 48.183 4.982a45.72 45.72 0 0 1 19.978 19.978C320 80.142 320 92.942 320 118.545v105.143c0 25.602 0 38.403-4.982 48.182a45.72 45.72 0 0 1-19.978 19.978c-9.779 4.982-22.58 4.982-48.183 4.982h-48c-25.602 0-38.403 0-48.182-4.982a45.7 45.7 0 0 1-19.978-19.978c-4.983-9.779-4.983-22.58-4.983-48.182z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__d",
    transform: "translate(-19.465 -45.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 164.259c0-25.602 0-38.404 4.983-48.182a45.7 45.7 0 0 1 19.978-19.978c9.779-4.983 22.58-4.983 48.182-4.983h48c25.602 0 38.404 0 48.183 4.983a45.7 45.7 0 0 1 19.977 19.978c4.983 9.778 4.983 22.58 4.983 48.182v105.143c0 25.602 0 38.404-4.983 48.182a45.7 45.7 0 0 1-19.977 19.978c-9.779 4.983-22.58 4.983-48.183 4.983h-48c-25.602 0-38.403 0-48.182-4.983a45.7 45.7 0 0 1-19.978-19.978C80 307.806 80 295.004 80 269.402z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__h",
    transform: "translate(-42.322 -91.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.857 148.259c0-6.312 5.117-11.429 11.429-11.429H240c6.312 0 11.429 5.117 11.429 11.429 0 6.311-5.117 11.428-11.429 11.428H114.286c-6.312 0-11.429-5.117-11.429-11.428"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__l",
    transform: "translate(-42.322 -137.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.857 193.973c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.429-11.428 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__p",
    transform: "translate(-42.322 -182.857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.857 239.687c0-6.311 5.117-11.428 11.429-11.428H240c6.312 0 11.429 5.117 11.429 11.428s-5.117 11.429-11.429 11.429H114.286c-6.312 0-11.429-5.117-11.429-11.429"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment_svg__t",
    transform: "translate(-42.322 -228.571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.857 285.402c0-6.312 5.117-11.429 11.429-11.429h102.857c6.312 0 11.428 5.117 11.428 11.429s-5.116 11.428-11.428 11.428H114.286c-6.312 0-11.429-5.116-11.429-11.428"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment_svg__g",
    width: 1.882,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment_svg__B",
    transform: "scale(.00184 .00142)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment_svg__k",
    width: 2.462,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment_svg__B",
    transform: "scale(.0024 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment_svg__o",
    width: 2.909,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment_svg__B",
    transform: "scale(.00284 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment_svg__s",
    width: 2.462,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment_svg__B",
    transform: "scale(.0024 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment_svg__w",
    width: 2.909,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment_svg__B",
    transform: "scale(.00284 .01563)"
  })))));
};
export default SvgAssessment;